/**
 * Reorders an object's keys based on a provided configuration array.
 *
 * @param {Record<string, Record<string, number>>} obj - The input object to reorder.
 * @param {string[]} config - An array of keys defining the desired order.
 * @returns {Record<string, Record<string, number>>} A new object with keys reordered according to the config.
 * @throws {Error} If the input object or config is invalid.
 * @example
 * const input = { 'a': { x: 1 }, 'b': { y: 2 }, 'c': { z: 3 } };
 * const config = ['c', 'a'];
 * const result = reorderKeys(input, config);
 * // result will be { 'c': { z: 3 }, 'a': { x: 1 } }
 */
export const reorderKeys = (
  obj: Record<string, Record<string, number>>,
  config: string[]
): Record<string, Record<string, number>> => {
  const orderedObj: Record<string, Record<string, number>> = {}

  for (const key of config) {
    if (key in obj) {
      orderedObj[key] = obj[key]
    }
  }

  return orderedObj
}
